import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	addFlagFailedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addFlagFailedDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeFlagFailedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeFlagFailedDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addFlagFailedTitleIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeFlagFailedTitleIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	addFlagFailedTitle: {
		id: 'software-add-issue-flag-with-comment.add-flag-failed-title',
		defaultMessage: "We couldn't flag this issue",
		description:
			'Title for the error message when the there is an error adding a flag (impediment) to the issue',
	},
	addFlagFailedDescription: {
		id: 'software-add-issue-flag-with-comment.add-flag-failed-description',
		defaultMessage: 'Check your connection and try adding the flag again.',
		description:
			'Description for the error message when the there is an error adding a flag (impediment) to the issue',
	},
	removeFlagFailedTitle: {
		id: 'software-add-issue-flag-with-comment.remove-flag-failed-title',
		defaultMessage: "We couldn't remove the flag from this issue",
		description:
			'Title for the error message when the there is an error removing the flag (impediment) from the issue',
	},
	removeFlagFailedDescription: {
		id: 'software-add-issue-flag-with-comment.remove-flag-failed-description',
		defaultMessage: 'Check your connection and try removing the flag again.',
		description:
			'Description for the error message when the there is an error removing the flag (impediment) from the issue',
	},
	addFlagFailedTitleIssueTermRefresh: {
		id: 'software-add-issue-flag-with-comment.add-flag-failed-title-issue-term-refresh',
		defaultMessage: "We couldn't flag this work item",
		description:
			'Title for the error message when the there is an error adding a flag (impediment) to the issue',
	},
	removeFlagFailedTitleIssueTermRefresh: {
		id: 'software-add-issue-flag-with-comment.remove-flag-failed-title-issue-term-refresh',
		defaultMessage: "We couldn't remove the flag from this work item",
		description:
			'Title for the error message when the there is an error removing the flag (impediment) from the issue',
	},
});
